import { ContentMetadata } from '@/lib/model';
import { cn } from '@/lib/utils';

type Props = {
  mobileContentMetadata: ContentMetadata;
  desktopContentMetadata: ContentMetadata;
  className?: string;
  dataTestId?: string;
};

export function PlatformTitle({
  mobileContentMetadata,
  desktopContentMetadata,
  className,
  dataTestId,
}: Props) {
  if (mobileContentMetadata?.title === desktopContentMetadata?.title) {
    return (
      <span className={className} data-testid={dataTestId}>
        {desktopContentMetadata?.title}
      </span>
    );
  }
  return (
    <>
      <span
        className={cn('inline lg:hidden', className)}
        data-testid={dataTestId}
      >
        {mobileContentMetadata?.title}
      </span>
      <span
        className={cn('hidden lg:inline', className)}
        data-testid={dataTestId}
      >
        {desktopContentMetadata?.title}
      </span>
    </>
  );
}
